import { render, staticRenderFns } from "./RegisterKennelForm2.vue?vue&type=template&id=3601bb5c"
import script from "./RegisterKennelForm2.vue?vue&type=script&lang=ts"
export * from "./RegisterKennelForm2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports